<template>
  <div class="bannner" ref="banner">
    <!--  -->
    <div v-if="routerPath != '/joinus'">
      <img
        src="../../assets/images/about_banner.png"
        class="visible-lg img-responsive"
        alt
      />
      <div class="banner_info_box">
        <span>掌上公交 您的公共出行好帮手</span>
      </div>
      <div class="banner_box container">
        <!-- <img
          src="../../assets/images/about_banner.png"
          alt
          class="hidden-xs hidden-lg img-responsive"
        /> -->
        <img
          src="../../assets/images/about_banner_mobile.png"
          class="visible-xs img-responsive"
          alt
        />
      </div>
    </div>
    <div v-else>
      <img
        src="../../assets/images/banner_joinus.png"
        class="visible-lg img-responsive"
        alt
      />
      <div class="banner_box container">
        <img
          src="../../assets/images/banner_joinus_mobile.png"
          class="visible-xs img-responsive"
          alt
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      routerPath: "",
    };
  },
  created() {
    this.routerPath = this.$route.path;
  },
};
</script>

<style lang="less" scoped>
.bannner {
  max-width: 1920px; /*no*/
  margin: auto;
  max-height: 260px; /*no*/
  // line-height: 16.25rem;
  position: relative;
  .container {
    width: 100%;
    padding-left: 0;
  }
  .banner_box {
    width: 545px; /*no*/
    padding: 0;
    background: url("../../assets/images/about_banner.png");
    background-size: 100%;
  }

  .banner_info_box {
    font-size: 70px; /*no*/
    color: #fff;
    text-align: center;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    // display: flex;
    align-items: center;
    justify-content: center;
    span {
      text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.36);
      //   display: inline;
    }
  }
}
@media (max-width: 539px) {
  .bannner {
    background-size: 100%;
    height: 106px;
    line-height: 106px;
    text-align: center;

    .banner_box {
      width: 100%;
      background: none;
      padding: 0;
    }

    .banner_info_box {
      color: #fff;
      font-weight: 500;
      font-size: 22px;
    }
  }
}
@media (min-width: 540px) {
  .bannner {
    .banner_info_box {
      display: flex;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/banner/about.banner.vue